import React from 'react';
import {Button} from "antd";

const ButtonFolder = () => {
    return (
        <span className="icon-center">
        <Button type="primary" danger shape="circle" size={"small"}/>
        </span>
    );
};

export default ButtonFolder;